
import head from '../mixins/MetaHead'

export default {
  components: {},
  mixins: [head],
  data () {
    return {
      stripeKey: process.env.STRIPE_KEY,
      stripeDonationId: process.env.STRIPE_DONATION_ID,
      paypalDonationId: process.env.PAYPAL_DONATION_ID,
      paypalDonationUrl: process.env.PAYPAL_DONATION_URL,
      title: 'Donate to FreeConvert.com',
      desc:
        "When we first started, we wanted to build the best online file converter. What we didn't realize was how expensive it is to run multiple dedicated servers to convert and encode files.",
      currentUrl: '/donate'
    }
  },
  head: {
    script: [
      { hid: 'stripe', src: 'https://js.stripe.com/v3/buy-button.js', defer: true },
    ]
  },
  mounted () {
    this.$store.commit('updateBreadcrumbs', [
      {
        url: this.localePath('/donate'),
        label: this.$t('donate')
      }
    ])
  }
}
